import script from "./IconChevron.vue?vue&type=script&setup=true&lang=js"
export * from "./IconChevron.vue?vue&type=script&setup=true&lang=js"

import "./IconChevron.vue?vue&type=style&index=0&id=091bb67c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-091bb67c"]])

export default __exports__